import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getAssetBrandListSaga = createAction(
  "GET_ASSET_BRAND",
  ({ payload, params }: SagaActionParams<Type.AssetBrandDto[]>) => ({
    payload,
    url: "/api/admin/brands" + (params ? params : ""),
  })
);
export const getAssetSubBrandListByBrandIdSaga = createAction(
  "GET_ASSET_SUB_BRAND",
  ({ payload, params, id }: SagaActionParams<Type.AssetBrandDto[]>) => ({
    payload,
    url: "/api/admin/brands/subbrands/" + id + (params ? params : ""),
  })
);
export const getAssetBrandDetailsSaga = createAction(
  "GET_ASSET_BRAND_DETAILS",
  ({ payload, id }: SagaActionParams<Type.AssetBrandDetailDto>) => ({
    payload,
    url: "/api/admin/brands/" + id,
  })
);
export const createAssetBrandSaga = createAction(
  "CREATE_ASSET_BRAND",
  ({ payload, body }: SagaActionParams<Type.AssetBrandDto>) => ({
    payload,
    url: "/api/admin/brands",
    body,
  })
);
export const updateAssetBrandSaga = createAction(
  "UPDATE_ASSET_BRAND",
  ({ payload, id, body }: SagaActionParams<Type.AssetBrandDto>) => ({
    payload,
    url: "/api/admin/brands/" + id,
    body,
  })
);
export const deleteAssetBrandSaga = createAction(
  "DELETE_ASSET_BRAND",
  ({ payload, id }: SagaActionParams<Type.AssetBrandDto>) => ({
    payload,
    url: "/api/admin/brands/" + id,
  })
);

const assetbrandsSaga = [
  takeLatest<any>(
    getAssetBrandListSaga.toString(),
    (payload: SagaGenericParams<Type.AssetBrandDto[]>) =>
      getSaga<Type.AssetBrandDto[]>(payload)
  ),
  takeLatest<any>(
    getAssetSubBrandListByBrandIdSaga.toString(),
    (payload: SagaGenericParams<Type.AssetBrandDto[]>) =>
      getSaga<Type.AssetBrandDto[]>(payload)
  ),
  takeLatest<any>(
    getAssetBrandDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.AssetBrandDetailDto>) =>
      getSaga<Type.AssetBrandDetailDto>(payload)
  ),
  takeLatest<any>(
    createAssetBrandSaga.toString(),
    (payload: SagaGenericParams<Type.AssetBrandDto>) =>
      postSaga<Type.AssetBrandDto>(payload)
  ),
  takeLatest<any>(
    updateAssetBrandSaga.toString(),
    (payload: SagaGenericParams<Type.AssetBrandDto>) =>
      putSaga<Type.AssetBrandDto>(payload)
  ),
  takeLatest<any>(
    deleteAssetBrandSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.AssetBrandDto>(payload)
  ),
];

export default assetbrandsSaga;
